// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4225":"88bdb0f4","4647":"0ae0a6b8","6648":"88bdb0f4","6884":"88bdb0f4","7319":"88bdb0f4","8269":"88bdb0f4","8725":"88bdb0f4"}[chunkId] + ".chunk.css";
};